import { Accordion } from "@mui/material";
import { makeStyles } from "../../providers/makeStyles";
import { Delete, ExpandMore } from "@mui/icons-material";
import { AccordionDetails, AccordionSummary, IconButton } from "@mui/material";
import { AthleteSummary } from "./AthleteSummary";
import { Notification } from "../notifications/Notification";
import { T } from "components/util/t";
import { AthleteRegistrationForm } from "./AthleteRegistrationForm";
import { TeamSummary } from "./TeamSummary";
import { TeamRegistrationForm } from "./TeamRegistrationForm";
import { useWatch } from "react-hook-form";

const SUMMARY = {
    "individual": AthleteSummary,
    "team": TeamSummary
};

const REGISTRATION_FORM = {
    "individual": AthleteRegistrationForm,
    "team": TeamRegistrationForm
};

const useStyles = makeStyles(theme => ({
    accordionRoot: {
        border: `2px solid ${theme.palette.border.main}`,
        borderRadius: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
    accordionExpanded: {
        "&&": {
            "&:last-of-type": {
                marginBottom: theme.spacing(1)
            }
        }
    },
    deleteIcon: {
        transform: "rotate(180deg)"
    }
}));
export const SelectedAthletes = ({ expanded, athletes, handleChange, removeAthlete, updateAthlete, appendAthlete, control, getValues, options, registrationOptions, captureFields, paymentOptions, isSeriesRegistration }) => {
    const classes = useStyles();
    const formAthletes = useWatch({ name: "athletes", control });

    return formAthletes.reduce((entries, entry, index) => {
        const entryIndex = entry.team_members ? formAthletes.findIndex(e => e.registrations_attributes[0]?.option_id === entry.registrations_attributes[0].option_id) : index;
        entries[entryIndex] = entries[entryIndex] || [];
        entries[entryIndex].push(entry);
        return entries;
    }, []).map((entries, index) => {
        const entry = entries[0];
        const type = entry.team_members ? "team" : "individual";
        const Summary = SUMMARY[type];
        const RegistrationForm = REGISTRATION_FORM[type];

        return (
            <Accordion
                key={index}
                classes={{ root: classes.accordionRoot, expanded: classes.accordionExpanded }}
                TransitionProps={{ unmountOnExit: true }}
                expanded={expanded === index}
                onChange={handleChange(index)}
            >
                <AccordionSummary
                    expandIcon={expanded === index
                        ? entries.length === 1 && <IconButton className={classes.deleteIcon} size="small" onClick={() => removeAthlete(index)}><Delete/></IconButton>
                        : <ExpandMore/>}
                    aria-controls={`${index}-content`}
                    id={`${index}-header`}
                >
                    <Summary entry={entry} entries={entries} />
                </AccordionSummary>
                <AccordionDetails>
                    {entry.registeredMessage && <><Notification type="info" text={<T {...entry.registeredMessage.props}>{entry.registeredMessage.text}</T>}/><br/></>}
                    <RegistrationForm
                        index={index}
                        control={control}
                        getValues={getValues}
                        displayName={!entry.id}
                        entry={type === "team" ? entries : entry}
                        options={options}
                        registrationOptions={registrationOptions}
                        captureFields={captureFields}
                        paymentOptions={paymentOptions}
                        isSeriesRegistration={isSeriesRegistration}
                        athletes={athletes}
                        formAthletes={formAthletes}
                        updateAthlete={updateAthlete}
                        appendAthlete={appendAthlete}
                        removeAthlete={removeAthlete}
                    />
                </AccordionDetails>
            </Accordion>
        );
    });
};
